module.exports = __webpack_public_path__ + "img/googleplay.08da39aa.png";